import { createSlice } from "@reduxjs/toolkit";
import { apiUrl } from "config/settings";
import http from 'http'
import { getFromLocalStorage, getMcEffective } from "config/functions";
import { applySensorUpdate } from 'containers/microControllers/b22/monitoring';
import { MC_SOFTWARE_TYPE } from 'config/const';

const McSlice = createSlice({
  name: "mc",
  initialState: {
    mcList: [],
    info: {},
  },
  reducers: {
    setMcList(state, action) { state.mcList = action.payload },

    setInfo(state, action) { state.info = action.payload },

    setSensor(state, action) {
      const dataSplit = action?.payload?.split('/');
      const list = Array.isArray(state.mcList) ? [...state.mcList] : [];

      if (list?.length === 0)
        return

      const newItem = { type: dataSplit[3], number: dataSplit[4], value: parseFloat(parseFloat(dataSplit[5]).toFixed(1)) };
      const mcIdx = list?.findIndex(item => item?.guid === dataSplit[2])

      if (mcIdx === -1) return

      const sensorIdx = list[mcIdx]?.sensors ?? 0
        ? list[mcIdx]?.sensors?.findIndex(s => s.number === newItem.number)
        : -1

      /**
       * If the controller disconnects from the network
       * send to the server and change the controller to connected.
       */
      if (list[mcIdx]?.isConnected === false) {
        const biz = getFromLocalStorage("biz");
        list[mcIdx].isConnected = true
        http.patch(`${apiUrl}/mc/connected/${biz?.path}/${dataSplit[2]}`, { isConnected: true })
          .then((res) => { })
          .catch(error => { })
      }

      if (!list[mcIdx]?.sensors)
        list[mcIdx].sensors = []

      if (sensorIdx !== -1)
        list[mcIdx].sensors[sensorIdx] = newItem;
      else
        list[mcIdx]?.sensors?.push(newItem);

      if (list[mcIdx]?.sensors?.length > 1) {
        const sen1 = list[mcIdx]?.sensors?.find(s => s?.number === '1')?.value
        const sen2 = list[mcIdx]?.sensors?.find(s => s?.number === '2')?.value

        if (list[mcIdx]?.turnOnDate) {
          list[mcIdx].effective = getMcEffective(list[mcIdx])
          list[mcIdx].delta = Math.abs(parseFloat(sen1 - sen2).toFixed(1))
        }
      }

      state.mcList = list;
    },

    setB22Sensor(state, action) {
      state.mcList = applySensorUpdate(Array.isArray(state.mcList) ? state.mcList : [], action.payload);
    },

    setB22Parent(state, action) {
      const parent = state.mcList.find(item => item.id === action.payload?.id && item.softwareType === MC_SOFTWARE_TYPE.B2_2);
      if (parent) Object.assign(parent, {
        name: action.payload.name, area: action.payload.area,
        notification: action.payload.notification, rangeSettings: action.payload.rangeSettings,
      });
    },

    setFault(state, action) {
      let data = action.payload
      const list = Array.isArray(state.mcList) ? [...state.mcList] : [];
      data = data.split('/')
      const findMcIndex = list.findIndex(mc => mc?.guid === data[2])
      if (findMcIndex !== -1) list[findMcIndex].fault = data[3] !== "none" ? data[3] : null
      state.mcList = list
    },

    changeMcCommand(state, action) {
      const data = action.payload
      const list = Array.isArray(state.mcList) ? [...state.mcList] : [];

      const findMcIndex = list.findIndex(mc => mc?.guid === data.guid)

      if (findMcIndex !== -1) {
        list[findMcIndex].turnOnDate = data?.turnOnDate
        list[findMcIndex].turnOffDate = data?.turnOffDate
        list[findMcIndex].boostPower = data?.boostPower

        list[findMcIndex].ac.fanSpeedActive = data?.ac?.fanSpeedActive ?? list[findMcIndex]?.ac?.fanSpeedActive
        list[findMcIndex].ac.modeActive = data?.ac?.modeActive ?? list[findMcIndex]?.ac?.modeActive
        list[findMcIndex].ac.setPointActive = data?.ac?.setPointActive ?? list[findMcIndex]?.ac?.setPointActive
      }

      state.mcList = list
    },

    changeModeActive(state, action) {
      const data = action?.payload?.split('/')
      const guid = data[2]
      const modeActive = data[3]

      const list = Array.isArray(state.mcList) ? [...state.mcList] : [];
      const findMcIndex = list.findIndex(mc => mc?.guid === guid)

      if (findMcIndex !== -1) {
        list[findMcIndex].ac.modeActive = modeActive
      }

      state.mcList = list
    },

    setIsConnectedMc(state, action) {
      const list = state?.mcList ? [...state.mcList] : [];
      const findMcIndex = list.findIndex(mc => mc?.guid === action?.payload?.guid)
      if (findMcIndex !== -1) {
        list[findMcIndex].isConnected = action.payload?.isConnected
        state.mcList = list
      }
    },
  },
});

export const {
  setMcList,
  setInfo,
  setSensor,
  setB22Sensor,
  setB22Parent,
  setFault,
  setStatus,
  // setAcCommands,
  changeModeActive,
  changeMcCommand,
  setIsConnectedMc,
} = McSlice.actions;

export default McSlice.reducer;
